import axios from 'axios';
import { message as AntdAlert } from 'antd';
import { put } from 'redux-saga/effects';
import * as actions from '../actions';
import { baseURL } from '../../../../globalUtils/axiosConfig';
import { errorHandler } from '../../../../components/unauthorizeHandler';

export function* handleFetchCoachTypes({ data }) {
  try {
    const response = yield axios.get(`${baseURL}/api/v2/types?type=coach`, {});
    const { success } = response.data;
    if (success) {
      yield put(actions.fetchCoachTypesSuccess(response.data.data));
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchCoachTypesError());
    AntdAlert.error('Something went wrong!');
    console.log(error);
  }
}

export function* handleUpdateCoachTypes({ data }) {
  const { position, id, name } = data;

  try {
    const response = yield axios.put(
      `${baseURL}/api/v2/types/${id}?type=coach`,
      {
        name,
        position,
      }
    );
    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateCoachTypesSuccess(data));
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.updateCoachTypesError(response.data.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateCoachTypesError(response.data.data));
    AntdAlert.error('Something went wrong!');
  }
}

export function* handleDeleteCoachTypes({ data }) {
  const { id } = data;
  try {
    const response = yield axios.delete(
      `${baseURL}/api/v2/types/${id}?type=coach`
    );
    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(actions.deleteCoachTypesSuccess(id));
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.deleteCoachTypesError(response.data.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.deleteCoachTypesError(response.data.data));
    AntdAlert.error('Something went wrong!');
  }
}

export function* handleCreateCoachTypes({ data }) {
  try {
    const newData = JSON.parse(JSON.stringify(data));
    delete newData.id;
    const response = yield axios.post(`${baseURL}/api/v2/types`, {
      ...newData,
    });
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.createCoachTypesSuccess(response.data.data));
    } else if (!success) {
      AntdAlert.error(response.data?.errors[0]);
      yield put(actions.createCoachTypesError(data.id));
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleUpdateCoachOrder({ data }) {
  const fd = new FormData();
  data.map((el, i) => fd.append(`types[${el.id}]`, i + 1));

  try {
    const response = yield axios.patch(`${baseURL}/api/v2/types/sort`, fd);
    const { success, message } = response.data;

    if (success) {
      AntdAlert.success(message);
      yield put(actions.updateCoachTypesOrderSuccess(data));
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.updateCoachTypesOrderError());
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateCoachTypesOrderError());
    AntdAlert.error('Something went wrong!');
  }
}
